import styles from './WingBanner.module.scss';
import close from '../../assets/wing/close.png';
import { isDesktop } from 'react-device-detect';
import kakao from '../../assets/kakaoLogo2.png';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function WingBanner() {
  const [isOpen, setIsOpen] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const storedDate = localStorage.getItem('wingBannerClosedDate');
    const today = new Date().toDateString();

    if (storedDate === today) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  }, [navigate]);

  const connectToChannelIO = () => {
    if ((window as any).ChannelIO) (window as any).ChannelIO('openChat');
  };

  const handleCloseForToday = () => {
    const today = new Date().toDateString();
    localStorage.setItem('wingBannerClosedDate', today);
    setIsOpen(false);
  };

  return (
    <div className={styles.outContainer}>
      {isDesktop && isOpen && (
        <div className={styles.container}>
          <div className={styles.bannerWrap}>
            <div className={styles.closeWrap}>
              <img
                src={close}
                alt="close"
                onClick={() => {
                  setIsOpen(false);
                }}
              />
            </div>
            <div className={styles.mypageWrap}>
              <span>You can find your tracking number in </span>
              <br />
              <span className={styles.hit}>
                My Page - Orders and deliveries.
              </span>
            </div>
            <div className={styles.emailWrap}>
              <span className={styles.hit}>
                A tracking number will be emailed
              </span>
              <span> to you once the product has shipped.</span>
              <br />
              <div className={styles.checkText}>
                <span>Please check your </span>
                <br />
                <span className={styles.hit}>spam folder</span>
                <span> as the email may end up there.</span>
              </div>
            </div>
            <div className={styles.contentWrap}>
              <span>
                For delivery inquiries and <br />
              </span>
              <span>
                other inquiries, <br />
              </span>
              <span>
                please contact us through <br />
              </span>
              <span className={styles.hit}>Channel Talk.</span>
              <div className={styles.kakaoIdWrap} onClick={connectToChannelIO}>
                <div>
                  <p>Connect to customer Service</p>
                </div>
              </div>
            </div>
            <span
              className={styles.closeLink}
              onClick={handleCloseForToday}
            >
              Don't show again today
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default WingBanner;
